import { galleryImages } from '../../../mocks/products';

export default function GallerySection() {
  return (
    <section className="py-24 bg-deep-black">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 mb-12">
        <div className="text-center">
          <h2 className="font-serif text-4xl lg:text-5xl text-white mb-4">
            Experience Our Space
          </h2>
          <p className="text-gray-400 text-lg">
            Step inside Central Florida's premier smoke shop
          </p>
        </div>
      </div>

      {/* Horizontal Scroll Gallery */}
      <div className="overflow-x-auto scrollbar-hide">
        <div className="flex gap-6 px-6 lg:px-8 pb-4" style={{ width: 'max-content' }}>
          {galleryImages.map((image, index) => (
            <div
              key={image.id}
              className="relative group cursor-pointer"
              style={{ 
                width: '600px', 
                height: '400px',
                animationDelay: `${index * 100}ms`
              }}
            >
              {/* Image Container */}
              <div className="relative w-full h-full rounded-2xl overflow-hidden">
                <img
                  src={image.url}
                  alt={image.caption}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                
                {/* Dark Overlay */}
                <div className="absolute inset-0 bg-deep-black/30 group-hover:bg-deep-black/50 transition-colors duration-300"></div>

                {/* Copper Frame on Hover */}
                <div className="absolute inset-0 border-2 border-copper opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-2xl"></div>

                {/* Caption */}
                <div className="absolute bottom-6 left-6">
                  <p className="text-white font-medium text-lg">{image.caption}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll Hint */}
      <div className="text-center mt-8">
        <p className="text-gray-500 text-sm flex items-center justify-center gap-2">
          <i className="ri-arrow-left-right-line"></i>
          Scroll to explore more
        </p>
      </div>
    </section>
  );
}
